import { fromJS } from 'immutable'
import { getOrgSettingsFromEmbed } from 'components/Customize/OrgSettings/Helpers'
import DefaultEmbedConstants from 'constants/DefaultEmbedConstants'
import OrgSettingsConstants from 'constants/OrgSettingsConstants'

class OrgSettingsStore extends Marty.Store {
  state = false
  handlers = {
    updateOrgSettingsFromEmbed: [DefaultEmbedConstants.DEFAULT_EMBED_PATCH_DONE],
    updateOrgSettings: [OrgSettingsConstants.ORG_SETTINGS_UPDATED],
    updateProperty: [
      OrgSettingsConstants.UPLOAD_WIDGET_ICON_FINISHED,
    ]
  }

  dehydrate() {
    if (!!this.state) {
      return this.state.toJS()
    }
    return this.state
  }

  rehydrate(dehydratedState) {
    return fromJS(dehydratedState)
  }

  getOrgSettings() {
    return this.fetch({
      id: 'getOrgSettings',
      dependsOn: [
        this.app.stores.OrgStore.getOrFetchCurrentOrg(),
        this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed(),
      ],
      locally() {
        if (!this.state) {
          const orgId = this.app.stores.OrgStore.getCurrentOrg().id
          const embed = this.app.stores.DefaultEmbedStore.state.embedByOrgId[orgId]

          this.state = getOrgSettingsFromEmbed(embed)
        }

        return this.state
      }
    })
  }

  updateOrgSettings(orgSettings) {
    this.state = orgSettings
  }

  updateOrgSettingsFromEmbed(embed) {
    this.state = getOrgSettingsFromEmbed(embed)
  }

  updateProperty(key, value) {
    this.state = this.state.setIn(key, value)
  }
}

export default OrgSettingsStore



// WEBPACK FOOTER //
// ./src/scripts/stores/OrgSettingsStore.js